<template>
    <div class="ui-page">
        <ui-page-header title="Inscrições" subtitle="Proponentes inscritos no processo, documentos enviados e julgamento da habilitação." />

        <div class="ui-list-bar">
            <ui-pills v-model="status" :items="statusPills" />
        </div>

        <ui-table-card clearable :can-clear="!!search" @clear="search = ''">
            <template #toolbar>
                <competitive-process-picker v-model="processId" />
                <v-text-field v-model="search" placeholder="Nome, CPF/CNPJ, e-mail ou protocolo" dense outlined hide-details prepend-inner-icon="mdi-magnify" class="ui-toolbar__search"></v-text-field>
            </template>
            <v-data-table :headers="headers" :items="rows" :loading="loading" disable-sort hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"
                :no-data-text="processId ? 'Nenhuma inscrição com esses filtros' : 'Selecione um processo'" loading-text="Carregando..." class="ui-clickable-rows" @click:row="open">
                <template v-slot:[`item.protocol`]="{ item }"><span class="ui-mono">{{ item.protocol || "—" }}</span></template>
                <template v-slot:[`item.name`]="{ item }">
                    <div class="ui-cell-main">{{ item.name }}</div>
                    <div class="ui-cell-sub">{{ item.person_type_label }} · {{ item.document_formatted }}<span v-if="item.representative_name"> · {{ item.representative_name }}</span></div>
                </template>
                <template v-slot:[`item.documents`]="{ item }">
                    {{ item.documents.total }} {{ item.documents.total === 1 ? "arquivo" : "arquivos" }}
                    <div v-if="item.documents.pending" class="ui-cell-sub cp-warn">{{ item.documents.pending }} para conferir</div>
                    <div v-else-if="item.documents.rejected" class="ui-cell-sub">{{ item.documents.rejected }} {{ item.documents.rejected === 1 ? "recusado" : "recusados" }}</div>
                </template>
                <template v-slot:[`item.submitted_at`]="{ item }">{{ formatStamp(item.submitted_at) }}</template>
                <template v-slot:[`item.status`]="{ item }">
                    <ui-badge set="cp-registration" :status="item.status" />
                    <div v-if="item.status === 'approved'" class="ui-cell-sub">{{ item.nda_accepted_at ? `NDA v${item.nda_version} assinado` : "NDA não assinado" }}</div>
                </template>
                <template v-slot:[`item.actions`]><v-icon small class="ui-cell-chevron">mdi-chevron-right</v-icon></template>
            </v-data-table>
            <template #footer>
                <ui-pagination :total="rows.length" :page.sync="page" :items-per-page.sync="itemsPerPage" />
            </template>
        </ui-table-card>

        <competitive-registration-sheet v-model="sheet.open" :registration-id="sheet.id" @changed="load" />
    </div>
</template>

<script>
import axios from "axios";
import CompetitiveProcessPicker from "@/components/competitive/CompetitiveProcessPicker.vue";
import CompetitiveRegistrationSheet from "@/components/competitive/CompetitiveRegistrationSheet.vue";
import processScope from "@/components/competitive/process-scope";
import { API, formatStamp, notifyError } from "@/components/competitive/competitive.util";

const STATUS_PILLS = [
    { value: "", text: "Todas" },
    { value: "submitted", text: "Em análise" },
    { value: "correction", text: "Em correção" },
    { value: "approved", text: "Habilitados" },
    { value: "rejected", text: "Inabilitados" },
    { value: "draft", text: "Rascunhos" },
    { value: "withdrawn", text: "Desistências" },
];

export default {
    name: "CompetitiveRegistrationList",
    components: { CompetitiveProcessPicker, CompetitiveRegistrationSheet },
    mixins: [processScope],
    data() {
        return {
            status: STATUS_PILLS.some((pill) => pill.value === this.$route.query.situacao) ? this.$route.query.situacao : "",
            rows: [],
            counts: {},
            loading: false,
            search: "",
            searchTimer: null,
            page: 1,
            itemsPerPage: 25,
            sheet: { open: false, id: null },
            headers: [
                { text: "Protocolo", value: "protocol", width: 110 },
                { text: "Proponente", value: "name" },
                { text: "Documentos", value: "documents", width: 150 },
                { text: "Enviada em", value: "submitted_at", width: 150 },
                { text: "Situação", value: "status", width: 170 },
                { text: "", value: "actions", align: "end", width: 40 },
            ],
        };
    },
    computed: {
        statusPills() {
            const total = Object.values(this.counts).reduce((sum, value) => sum + value, 0);
            return STATUS_PILLS.map((pill) => ({ ...pill, count: pill.value ? this.counts[pill.value] || 0 : total }));
        },
    },
    watch: {
        status(value) {
            this.$router.replace({ query: { ...this.$route.query, situacao: value || undefined } }).catch(() => {});
            this.load();
        },
        search() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => this.load(), 300);
        },
    },
    methods: {
        formatStamp,
        onProcess() {
            this.page = 1;
            this.load();
        },
        async load() {
            if (!this.processId) return;
            this.loading = true;
            try {
                const result = await axios.get(`${API}/processes/${this.processId}/registrations`, { params: { status: this.status || undefined, search: this.search || undefined } });
                this.rows = result.data.content.data;
                this.counts = result.data.content.counts;
            } catch (error) {
                notifyError(this, error);
            } finally {
                this.loading = false;
            }
        },
        open(item) {
            this.sheet = { open: true, id: item.id };
        },
    },
};
</script>

<style lang="scss">
@import "../../components/competitive/competitive";
</style>
